import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css" 
import img from "./pics/khufiya.png";
const Khufiya = () => { 
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">Khufiya</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 4.5</div> <div className="genre">Genre: Spy,Thriller,Suspense</div>
            <p>Khufiya is one of the most captivating thriller movies I've had the pleasure of watching recently. It begins with the chilling murder of an undercover spy, orchestrated by a cunning mole deeply embedded within the R and AW Agency. From the very start, this film plunges you into a world of spying, intrigue, and relentless suspense.</p>
<br/>
<p>What truly sets this movie apart is its meticulous attention to detail when it comes to the intricacies of espionage and investigation. It takes us on a gripping journey through the painstaking process of hunting down this insidious mole, even delving into the lives of the mole's unsuspecting family members. With each passing moment, the plot unfurls in unexpected and exhilarating directions, leaving the audience perpetually on the edge of their seats.</p>
<br/>
<p>Another standout feature of this film is the impeccably developed characters, each of whom receives their fair share of the spotlight. The ensemble cast delivers exceptional performances that breathe life into their respective roles. Tabu, in her portrayal of an R and AW agent, embodies a powerful and charismatic female protagonist who commands attention and respect. It's worth noting that her remarkable acting prowess shines through even at the age of 51, proving that talent knows no bounds.</p>
<br/>
<p>Wamiqa Gubbi's role in the movie also deserves special mention. Her portrayal is not only bold and sexy but also layered and compelling, making her character a captivating enigma throughout the film. It's refreshing to see an actress who fearlessly embraces complexity and delivers a standout performance.</p>
<br/>
<p>Ali Fazal, too, leaves an indelible mark with his exceptional portrayal in the movie. His performance is nothing short of fantastic, adding depth and authenticity to the narrative. His character's journey and evolution are portrayed with nuance and finesse, making him a crucial element of the film's success.</p>
<br/>
<p>The movie does deliver the message of being loyal to our country, providing viewers with a thought-provoking exploration of patriotism and the moral complexities that come with it.</p>
<br/>
<p>In conclusion, this thriller movie is a masterclass in suspense and intrigue. With its meticulously crafted plot, authentic portrayal of espionage, and exceptional performances from a talented cast, it's no wonder that it kept me engrossed from start to finish. This film not only delivers a thrilling cinematic experience but also offers a rare glimpse into the high-stakes world of espionage, making it a must-watch for any fan of the genre.</p>
           <br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default Khufiya;

 


